module.exports = __webpack_public_path__ + "static/media/close.886c1f29.svg";